export const environment = {
  production: true,
  buildId: '3046991276720191',
  configFile: 'config.json',
};
